
export const legal = {
  title: 'LEGAL',
  subtitle: '法的規定およびサイトポリシー',

  // Section 1
  section1_title: '組織概要 / 特定商取引法に基づく表記',
  org_name_label: '機関名',
  org_name_value: 'ドリーム実現アカデミー（DREAM REALIZATION ACADEMY）',
  director_label: '運営統括責任者（理事長）',
  director_value: '廣瀬 進二',
  address_label: '所在地',
  address_value: '〒455-0822\n愛知県名古屋市港区甚兵衛通5丁目16番地\nクロスゴスペルチャーチ2階',
  contact_label: '連絡先',
  contact_value: 'メールアドレス：info@dr-academy.net\n※お取引やサービスに関するお問い合わせは、記録の正確性を期すため、原則として当サイトの「INQUIRY（照会）」フォームまたはメールにて承っております。',
  program_price_label: '提供プログラムおよび販売価格',
  program_price_value: 'DREAM CODE 波動共鳴プログラム（全48講座・基本プログラム）：440,000円（税込）\n※法人および教育機関向けのカスタマイズ導入については、事前の要件定義に基づき個別にお見積もりいたします。',
  additional_fees_label: '商品代金以外の必要料金',
  additional_fees_value: '・プログラム受講およびシステム利用に伴うインターネット通信費用',
  payment_method_label: 'お支払い方法',
  payment_method_value: 'クレジットカード決済（専用の非公開リンクよりご案内いたします）',
  delivery_label: '引き渡し時期（役務の提供時期）',
  delivery_value: '所定の適性面談および受講手続き（決済）の完了後、ご案内する専用学習システムまたは指定の開始日にて、速やかにプログラムの提供を開始いたします。',
  cancellation_label: 'キャンセル・返金について',
  cancellation_value: '提供するプログラムおよびデジタルコンテンツの特性上、原則として受講手続き完了後（決済後）のキャンセルおよびご返金はお受けしておりません。あらかじめご了承ください。',

  // Section 2
  section2_title: 'プライバシーポリシー',
  privacy_intro_title: '',
  privacy_intro_text: 'ドリーム実現アカデミー（以下、「当機関」）は、当機関が提供する教育プログラムおよび各種サービスにおける、個人の情報の取り扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」）を定めます。',
  privacy_1_title: '1. 情報の取得と利用目的',
  privacy_1_text: '当機関は、INQUIRY（ご照会）フォーム等を通じて取得したお名前、ご所属機関名、連絡先等の情報を、以下の目的でのみ利用いたします。\n・ご照会に対する回答および最適なプログラムの提案\n・プログラムの提供、運営、およびそれに伴う事務連絡\n・当機関が主催する国際会議、セミナー、教育情報のご案内',
  privacy_2_title: '2. 個人情報の第三者提供',
  privacy_2_text: '当機関は、法令に基づく場合を除き、事前の同意を得ることなく、取得した個人情報を第三者に提供・開示することは一切ありません。',
  privacy_3_title: '3. 安全管理措置',
  privacy_3_text: '当機関は、個人情報の漏洩、滅失または毀損の防止、その他個人情報の安全管理のために、国際基準に則った必要かつ適切な措置を講じます。',
  privacy_4_title: '4. 免責事項',
  privacy_4_text: '当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について当機関は一切の責任を負いません。',
  privacy_5_title: '5. お問い合わせ窓口',
  privacy_5_text: '本ポリシーに関するお問い合わせは、当サイトの「INQUIRY」フォームより事務局までご連絡ください。',

  // Section 3
  section3_title: '利用規約および免責事項',
  terms_1_title: '1. 知的財産権の保護',
  terms_1_text: '当サイトに掲載されている全てのコンテンツ（文章、画像、デザイン、DREAM CODEに関する「48の法則」等の構造図・カリキュラム体系）に関する著作権その他の知的財産権は、ドリーム実現アカデミーおよび創設者に帰属します。無断での複製、転載、改変、および商業目的での使用を固く禁じます。',
  terms_2_title: '2. プログラムの性質と免責事項',
  terms_2_text: '「DREAM CODE 波動共鳴プログラム」は、脳科学、行動心理学、量子力学の概念的視座を統合し、個人の認知構造の再設計を支援する教育フレームワークです。\n当機関は、本プログラムの学術的整合性と教育的価値の向上に努めておりますが、本プログラムは特定の疾患の治療を目的とした医療行為を代替するものではありません。また、受講者の絶対的な経済的成功や特定の成果を法的に保証するものではないことを明記いたします。',
  terms_3_title: '3. 規約の変更',
  terms_3_text: '当機関は、必要と判断した場合には、事前の予告なく本規約を変更することができるものとします。変更後の規約は、当サイトに掲示された時点から効力を生じるものとします。',
};
